/**
 * Created by henian.xu on 2019/10/12.
 *
 */

// import './pages/index.scss';
// import './index.css';
import Vue from 'vue';
import Router, { Route, RouteConfig } from 'vue-router';
import { getUniqueId, isFunction, GlobalVar, Runtime } from '@vmf/shared';

Vue.use(Router);

export interface InitialMethod {
    (): Promise<any>;
    isCalled?: boolean;
}

export const initialMethodMap: { [k: string]: InitialMethod } = {};
export const routes: RouteConfig[] = [];

async function initAppData(to: Route): Promise<any> {
    const {
        meta: { uniqueId },
    } = to;
    const initialMethod: InitialMethod = initialMethodMap[uniqueId];
    let res;
    if (!initialMethod || initialMethod.isCalled) return res;
    res = await initialMethod();
    console.log('初始路由数据完成', 222222);
    initialMethod.isCalled = true;
    return res;
}

export const router = new Router({
    mode: 'hash', // 'hash' | 'history' | 'abstract'
    linkActiveClass: 'active',
    linkExactActiveClass: 'exact-active',
    ...(GlobalVar.appConfig && GlobalVar.appConfig.ROUTER_DEFAULT_CONFIG),
});

router.beforeEach((to: Route, from: Route, next) => {
    if (to.path === '/login') {
        next();
        return;
    }
    initAppData(to)
        .then(() => {
            next();
        })
        .catch(() => {
            next();
        })
        .finally(() => {
            // noop
        });
});

// eslint-disable-next-line no-shadow
function markRoutes(routes: RouteConfig[], uniqueId: string): RouteConfig[] {
    return routes.map(route => {
        const res: RouteConfig = {
            ...route,
            meta: {
                ...route.meta,
                uniqueId,
            },
        };

        if (route.children && route.children.length) res.children = markRoutes(route.children, uniqueId);
        return res;
    });
}

// TODO 检验重复的 route
export function addRoutes(routesList: RouteConfig[], beforeEach?: InitialMethod) {
    const uniqueId = getUniqueId('router-');
    const routeList = markRoutes(routesList, uniqueId);
    if (isFunction(beforeEach)) {
        initialMethodMap[uniqueId] = beforeEach;
    }
    routes.splice(routes.length, 0, ...routeList);
    router.addRoutes(routeList);
}

// 设置运行时 router
Runtime.setRouter(router);
